import React from 'react';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import { Image } from 'antd';
import './index.less';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PageLayout from '../../Components/pageLayout';

import honors1 from '../../static/honors1.webp'
import honors2 from '../../static/honors2.webp'
import honors3 from '../../static/honors3.webp'
import honors4 from '../../static/honors4.webp'
import honors5 from '../../static/honors5.webp'
import honors6 from '../../static/honors6.webp'
import honors7 from '../../static/honors7.webp'
import honors8 from '../../static/honors8.webp'
import honors9 from '../../static/honors9.webp'
import honors10 from '../../static/honors10.webp'
import honors11 from '../../static/honors11.webp'
import honors12 from '../../static/honors12.webp'
import honors13 from '../../static/honors13.webp'
import fit2023 from '../../static/2023fit.jpg'
import fit2024 from '../../static/2024fit.jpg'
import honors14 from '../../static/honors14.jpg'

const Honors: React.FC = () => {
    const history = useHistory();

    // 荣誉图片数据
    const honors = [
        { id: 16, src: honors14, alt: '中基透明指数FTI2025证书（浙江省）' },
        { id: 1, src: fit2024, alt: 'fit2024' },
        { id: 2, src: fit2023, alt: 'fit2023' },
        { id: 3, src: honors1, alt: '荣誉图片1' },
        { id: 4, src: honors2, alt: '荣誉图片2' },
        { id: 5, src: honors3, alt: '荣誉图片3' },
        { id: 6, src: honors4, alt: '荣誉图片4' },
        { id: 7, src: honors5, alt: '荣誉图片5' },
        { id: 8, src: honors6, alt: '荣誉图片6' },
        { id: 9, src: honors7, alt: '荣誉图片7' },
        { id: 10, src: honors8, alt: '荣誉图片8' },
        { id: 11, src: honors9, alt: '荣誉图片9' },
        { id: 12, src: honors10, alt: '荣誉图片10' },
        { id: 13, src: honors11, alt: '荣誉图片11' },
        { id: 14, src: honors12, alt: '荣誉图片12' },
        { id: 15, src: honors13, alt: '荣誉图片13' }
    ];

    // 轮播配置
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
    };

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>荣誉认证</h1>
                <div className='honors-carousel'>
                    <Slider {...settings}>
                        {honors.map((honor) => (
                            <div key={honor.id} className='honor-slide'>
                                <Image src={honor.src} alt={honor.alt} preview={{ src: honor.src }} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        } />
    );
};

export default Honors;